import {
  isSupportedLocale,
  normalizeLocale,
} from '~/utils/locale'

export default ({
  app
}) => {
  //在页面加载时读取localStorage里的状态信息
  app.router.beforeEach((to, from, next) => {
    const queryLocale = to.query?.lang
    const locale = normalizeLocale(queryLocale)
    if (isSupportedLocale(queryLocale) && app.i18n?.locale !== locale) {
      app.$loadLanguageAsync(locale).finally(() => next())
      return
    }
    // if (process.client) {
    //   app.store.replaceState(Object.assign(app.store.state, JSON.parse(localStorage.getItem("storeState"))));
    //   //在页面刷新时将vuex里的信息保存到localStorage里 
    //   window.addEventListener("beforeunload", () => {
    //     app.store.state.isLogin = Boolean(app.store.state.isLogin)
    //     app.store.state.report = false
    //     localStorage.setItem("storeState", JSON.stringify(app.store.state))
    //   })

    // }

    next()
  })
  // app.router.afterEach((to, from) => {
  //   if (process.client && to.path !== from.path) {
  //     const targetScript = document.querySelector('#hwTagScript');
  //     if (targetScript) {
  //       targetScript.remove();
  //     }
  //     if (window.hwtag) {
  //       delete window.hwtag;
  //     }
  //     window.hwDataLayer = [];

  //     const script = document.createElement('script');
  //     script.async = true;
  //     script.src = 'https://t.xp-pen.com/hwtag.min.js';
  //     script.id = 'hwTagScript';
  //     document.head.appendChild(script);

  //     window.hwDataLayer = window.hwDataLayer || [];
  //     window.hwtag = function hwtag() {
  //       hwDataLayer.push(arguments);
  //     }
  //     window.hwtag('config', 'xppen_cm');
  //   }
  // });


}
